import { areArrayEquals, isArray } from '../../../utils'

import { type Capability, createIndexedCapabilities, selectAuthenticatedCapabilities } from '../../../domain'

import { useAppState, useAppUsecase } from '../State'
import { getRouteCapabilities, isStorybookRoute } from './Config'
import type { AbsoluteRoutePath } from './Domain'

export const useHasCapabilities = (): (requiredCapabilitiesAlternativesOrRoute: readonly Capability[] | AbsoluteRoutePath) => boolean => {
    const [hasCapabilities] = useAppState(
        (s) => [createIndexedCapabilities(s), selectAuthenticatedCapabilities(s) ?? []],
        ([, a]: [unknown, readonly Capability[]], [, b]: [unknown, readonly Capability[]]) => areArrayEquals(a, b, { sort: false })
    )
    const isStorybookEnabledUsecase = useAppUsecase('isStorybookEnabledUsecase')

    return (alternativesOrRoute) => {
        /**
         * Storybook is an internal, dev/demo-only page: gated by app config rather than a backend capability
         */
        if (!isArray(alternativesOrRoute) && isStorybookRoute(alternativesOrRoute) && !isStorybookEnabledUsecase.invoke()) {
            return false
        }

        const alternatives = isArray(alternativesOrRoute)
            ? [alternativesOrRoute]
            : getRouteCapabilities(alternativesOrRoute).map((capabilities) => capabilities.required)
        return alternatives.some(hasCapabilities)
    }
}
